export const GET_COMPANIES = 'GET_COMPANIES';
export const COMPANY_REQUEST = 'COMPANY_REQUEST';
export const CREATE_COMPANY = 'CREATE_COMPANY';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const SUCCESS_COMPANY = 'SUCCESS_COMPANY';
export const SET_USER_AUTHORIZE_COMPANIES = 'SET_USER_AUTHORIZE_COMPANIES';
export const COMPANY_REQUEST_FAILURE = 'COMPANY_REQUEST_FAILURE';
export const DELETE_COMPANY = 'DELETE_COMPANY';